/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link } from "react-router";
import { HeaderLogo } from "../Data/Assets/Images";
import ScrambleText from "../Styles/ScrambleText";
import "../App.css";

const Navbar = ({ setActiveFilter }) => {
  const [activeButton, setActiveButton] = useState("all");

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    setActiveFilter(buttonName);
  };

  return (
    <div className="flex flex-row lg:justify-start justify-between items-center gap-10 py-2 lg:py-5 font-pathway font-semibold tracking-widest text-white">
      <div className="w-24 h-24 lg:w-32 lg:h-32">
        <Link onClick={() => handleButtonClick("all")} to={"/"}>
          <img src={HeaderLogo} alt="badhacker logo" />
        </Link>
      </div>
      <div className="flex flex-col justify-between items-end lg:items-start">
        <button
          className={`hover:text-themeGreen transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] ${
            activeButton === "all" ? "text-themeGreen" : "navbar-button"
          }`}
          onClick={() => handleButtonClick("all")}
        >
          <Link to={"/"}>
            <ScrambleText text="ALL WORK" />
          </Link>
        </button>
        <button
          className={`hover:text-themeGreen transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] ${
            activeButton === "tools" ? "text-themeGreen" : "navbar-button"
          }`}
          onClick={() => handleButtonClick("tools")}
        >
          <Link to={"/"}>
            <ScrambleText text="TOOLS" />
          </Link>
        </button>
        <button
          className={`hover:text-themeGreen transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] ${
            activeButton === "games" ? "text-themeGreen" : "navbar-button"
          }`}
          onClick={() => handleButtonClick("games")}
        >
          <Link to={"/"}>
            <ScrambleText text="GAMES" />
          </Link>
        </button>
        <button
          className={`hover:text-themeGreen transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] ${
            activeButton === "informative" ? "text-themeGreen" : "navbar-button"
          }`}
          onClick={() => handleButtonClick("informative")}
        >
          <Link to={"/"}>
            <ScrambleText text="INFORMATIVE" />
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Navbar;
